const CASCADER_PANEL_INJECTION_KEY = Symbol();

export { CASCADER_PANEL_INJECTION_KEY };
//# sourceMappingURL=types.mjs.map
